<template>
	<v-app id="inspire">

		<v-navigation-bar v-if="!loginView" @close-drawer="$root.drawer = null"/>

		<!-- <v-page-header v-if="!loginView" :color="$root.colorHeader" :titulo="$root.titleHeader" /> -->

		<v-main>
			<router-view
				@drawer-change="$root.drawer = !$root.drawer"
				@snack="v => (snackbar = v)"
			/>
			<v-page-footer v-if="!loginView" />
		</v-main>

		<v-snackbar app v-model="snackbar.show" :timeout="1500">
			{{ snackbar.text }}
		</v-snackbar>
		<v-dialog v-if="$root.dialog" v-model="dialog" width="500">
			<v-card>
				<v-card-title class="headline">
					{{ $root.dialog.title }}
				</v-card-title>

				<v-card-text>
					{{ $root.dialog.msg }}
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="$root.dialog = null">
						Fechar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-app>
</template>

<script>
import VNavigationBar from '@/components/NavigationBar.vue';
import VPageFooter from '@/components/PageFooter.vue';
//import VPageHeader from '@/components/PageHeader.vue';

export default {
	//components: { VNavigationBar, VPageFooter, VPageHeader },
	components: { VNavigationBar, VPageFooter },
	props: {
		source: String
	},
	data: () => ({
		drawer: null,
		snackbar: {
			show: false,
			text: null
		},
		showAtalhosClearInterval: null
	}),
	computed: {
		dialog() {
			return this.$root.dialog && this.$root.dialog.msg;
		},

		loginView() {
			return this.$route && this.$route.name === 'Login';
		}
	},
	async mounted() {
		this.showAtalhosClearInterval = setInterval(() => {
			this.$root.showAtalhos = false;
		}, 5000);

	},
	destroyed() {
		clearInterval(this.showAtalhosClearInterval);
	}
};
</script>
